import { render, staticRenderFns } from "./SupplierBill.vue?vue&type=template&id=2a4562fa&"
import script from "./SupplierBill.vue?vue&type=script&lang=js&"
export * from "./SupplierBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports